import easyCheckApi, { easyCheckRequest } from '../api/config';

export const chequeAttachmentService = {
  getAttachments: (chequeId) =>
    easyCheckRequest(() => easyCheckApi.get(`/cheques/${chequeId}/attachments`)),

  uploadAttachment: (chequeId, file, documentTypeId) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('documentTypeId', documentTypeId);
    return easyCheckRequest(() =>
      easyCheckApi.post(`/cheques/${chequeId}/attachments`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 60000,
      })
    );
  },

  downloadAttachment: async (attachmentId) => {
    const response = await easyCheckApi.get(`/cheque-attachments/${attachmentId}/download`, {
      responseType: 'blob',
    });

    // Check if response is JSON (presigned URL for images) or blob (decompressed file)
    const contentType = response.headers['content-type'] || '';
    if (contentType.includes('application/json')) {
      // It's a JSON response with a presigned URL — parse it
      const text = await response.data.text();
      const json = JSON.parse(text);
      return { success: json.Success ?? json.success, data: json.Data ?? json.data };
    }

    // It's a raw file — create a blob URL
    const disposition = response.headers['content-disposition'] || '';
    const fileNameMatch = disposition.match(/filename="?([^";\n]+)"?/);
    const fileName = fileNameMatch ? fileNameMatch[1] : 'attachment';
    const blob = new Blob([response.data], { type: contentType });
    const url = URL.createObjectURL(blob);
    return { success: true, data: { url, fileName, contentType, isBlob: true } };
  },

  deleteAttachment: (attachmentId) =>
    easyCheckRequest(() => easyCheckApi.delete(`/cheque-attachments/${attachmentId}`)),

  getStorageUsage: () =>
    easyCheckRequest(() => easyCheckApi.get('/company-storage')),
};
